var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevokeToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.495 12.18a4.852 4.852 0 0 1 6.238-.524.92.92 0 0 1 .047-.05l.574-.574 1.285 1.287-.573.574a.922.922 0 0 1-.079.068 4.851 4.851 0 0 1-7.492 6.08 4.851 4.851 0 0 1 0-6.86Zm5.573 1.287a3.032 3.032 0 1 0-4.287 4.289 3.032 3.032 0 0 0 4.287-4.29Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.042 18.088a.75.75 0 0 1-1.06 1.061l1.06-1.061Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.405 3.98a1.517 1.517 0 0 1 2.144 0l2.11 2.11a.91.91 0 0 1-1.286 1.287l-1.896-1.896-1.733 1.734L18.64 9.11a.91.91 0 0 1-1.287 1.287L15.459 8.5l-2.508 2.506 7.092 7.08-.53.531-.53.532L4.68 4.87l-.051-.057a.75.75 0 0 1 1.054-1.056l.057.05 5.923 5.914 5.742-5.741Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevokeToken);
export default __webpack_public_path__ + "static/media/revoke-token.7349d5fc4526951b27bba793d0f36068.svg";
export { ForwardRef as ReactComponent };